import React, { useState, useEffect,useRef } from "react";
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from '../common/DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata,Fetchupdatequery,Fetchfileupload1,FetchsavePoRows } from '../../../services/process/BRS1/brsService7';
import { CreateData} from '../../../services/process/process_data/process_data';
import { Icon } from 'semantic-ui-react';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import excelIcon from '../../../assets/images/excel.png'; // Ensure these icons exist
import pdfIcon from '../../../assets/images/pdf.png';
import logo from '../../../assets/images/1.png'; // Adjust the path to your image
import jsPDF from 'jspdf';
import 'jspdf-autotable';

function PoCreation() {
  const [formData, setFormData] = useState({});
  const [formData2, setFormData2] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [fields, setFields] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [rowData1, setRowData1] = useState([]);
  const [rowData2, setRowData2] = useState([]);
  const [fields1, setFields1] = useState(null);
  const [fields2, setFields2] = useState(null);
  const [fields3, setFields3] = useState(null);
  const [columnDefs, setColumnDefs] = useState([]);
  const [columnDefs1, setColumnDefs1] = useState([]);
  const [columnDefs2, setColumnDefs2] = useState([]);
  const [columnDefs3, setColumnDefs3] = useState([]);
  const [isDiv1Open, setIsDiv1Open] = useState(true);
  const [isDiv2Open, setIsDiv2Open] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false );
  const [filterconditions,setFilterconditions] =  useState([{"is_active" : 1,"entity_id" : userCredentials.selectedentity,"tenant_id": userCredentials.tenants_id,"group_id": userCredentials.groups_id}]);
  const [editMode, setEditMode] = useState(false); // State to track if in edit mode
  const toggleDiv1 = () => setIsDiv1Open(!isDiv1Open);
  const toggleDiv2 = () => setIsDiv2Open(!isDiv2Open);
  const gridRef1 = useRef(null);



  const fetchData = async () => {
    await fetchFieldInfo(54, setFields2, setColumnDefs2);
    await fetchFieldInfo(35, setFields1, setColumnDefs);
    await fetchFieldInfo(60, setFields2, setColumnDefs3);
    await fetchFieldInfo(34, setFields, setColumnDefs);
    await fetchFieldInfo(62, setFields2, setColumnDefs1);
    await fetchFieldInfo(63, setFields3, setColumnDefs); 
   setLoading(false); // Stop loading after fetching all field info
  };

  const fetchData2 = async () => {
    fetchFieldInfo2();
    setLoading(false); // Stop loading after fetching all field info
  };


  useEffect(() => {
  fetchData();
  fetchData2();
  }, []);

  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

const handleTabChange1 = (index) => {
  setActiveTab(index);
  console.log("User switched to tab:", index);
  
  if (index === 0) {
    // View Purchase Orders tab
    fetchData2();
  } else if (index === 1) {
    // Purchase Order File Upload tab
    fetchFieldInfo3();
  }
};


 const fetchFieldInfo = async (headerConfigId, setFieldsFunc, setColumnDefsFunc) => {
  const payload = { headerconfig_id: headerConfigId,filterconditions: filterconditions};
  
    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], 
        payload, 
        FileUploadCredentials[0]
      );
  
      const data = response.data;
      console.log("fetched data",data)

      if (data.fields?.length) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
          sortable: true,
          filter: true 

        }));
	if (headerConfigId === 54){
        columns.push({
          headerName: "View",
          field: "edit",
          cellRendererFramework: (params) => (
    <Icon
      name="eye"
      style={{ cursor: 'pointer' }}
      onClick={() => handleEditClick(params.data)}
    />
          ),
          width: 100, // Set width for the edit column
        });} else if (headerConfigId === 60){
        columns.unshift({
        headerCheckboxSelection: true, // Add this line for the checkbox selection
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true, // Add this line for the checkbox selection
        width: 20
      },
     );}

        setColumnDefsFunc(columns);
        setFieldsFunc(data.fields);
        console.log("updation completed")
        return { fields: data.fields };
      }
    } catch (error) {
      console.error(`Error fetching field info for headerConfigId ${headerConfigId}:`, error);
      setError("Error fetching fields data");
        return { fields: []};
    }
  };
    

  const handleEditClick = async(row) => {
    console.log(row)
    const payload = { query: `SELECT * from paymentsuat.stg_purchase_order where stg_setting_value = ${row.file_uploads_id}` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData2(data);
        setShowPopup(true);

        console.log("data fetched",data)
      }
    } catch (error) {
      console.error("Error fetching Institutional Invoice data:", error);
      setError("Error fetching department data");
    }
  };


  const fetchFieldInfo2 = async () => {
    const payload = { query: `SELECT IFNULL(DATE_FORMAT(admin_process_date, '%d-%m-%Y'), '') AS 'admin_process_date', IFNULL(TRIM(bill_no), '') AS 'bill_no', IFNULL(DATE_FORMAT(bill_date, '%d-%m-%Y'), '') AS 'bill_date',
 IFNULL(TRIM(vendor_name), '') AS 'vendor_name', IFNULL(TRIM(direct_no), '') AS 'direct_no', IFNULL(TRIM(employee_id), '') AS 'employee_id', IFNULL(TRIM(employee_name), '') AS 'employee_name', IFNULL(TRIM(description), '') AS 'description', IFNULL(TRIM(gl_code), '') AS 'gl_code', IFNULL(TRIM(cost_centre_code), '') AS 'cost_centre_code', IFNULL(CONVERT(net_value, CHAR), '0.00') AS 'net_value', IFNULL(CONVERT(transaction_fees, CHAR), '0.00') AS 'transaction_fees', IFNULL(CONVERT(igst_amount, CHAR), '0.00') AS 'igst_amount', IFNULL(CONVERT(cgst_amount, CHAR), '0.00') AS 'cgst_amount',
 IFNULL(CONVERT(sgst_amount, CHAR), '0.00') AS 'sgst_amount', IFNULL(CONVERT(total, CHAR), '0.00') AS 'total' FROM paymentsuat.institutional_invoices WHERE is_active = 1 AND processing_status = 'Processed' AND entity_id = '${userCredentials.selectedentity}';` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData(data);
        console.log("data fetched",data)
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };

  const fetchFieldInfo3 = async () => {
    const payload = { query: `SELECT file_uploads_id,IFNULL(TRIM(file_name), '') AS 'file_name', IFNULL(CONVERT(file_size, CHAR), '0') AS 'file_size_bytes', IFNULL(TRIM(status), '') AS 'status', IFNULL(TRIM(comments), '') AS 'comments', DATE_FORMAT(uploaded_time, '%d-%m-%Y %H:%i:%s') AS 'created_on' FROM process_data.file_uploads WHERE source_id = 207 and is_active = 1 AND entities_id = ${userCredentials.selectedentity} ORDER BY file_uploads_id DESC LIMIT 30;` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData1(data);
        console.log("data fetched",data)
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };




const gridRef = useRef();

const onBtnExportCSV = () => {
  gridRef.current.api.exportDataAsCsv();
};

const exportToPDF = () => {
  const filteredColumns = columnDefs1.filter((col) => col.field !== "id"); // Exclude 'id'
  const tableColumn = filteredColumns.map((col) => col.headerName);

  const gridApi = gridRef.current.api;
  const displayedRows = [];
  gridApi.forEachNodeAfterFilter((node) => {
    displayedRows.push(node.data); // Get filtered rows
  });

  const tableRows = displayedRows.map((row) =>
    filteredColumns.map((col) =>
      row[col.field] !== undefined && row[col.field] !== null ? String(row[col.field]) : ''
    )
  );

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a3", // A3 landscape for more width
  });

  // Add logo
  const imgWidth = 28;
  const imgHeight = 14;
  const imgX = 10;
  const imgY = 5;
  doc.addImage(logo, "PNG", imgX, imgY, imgWidth, imgHeight);

  // Add title
  doc.setFontSize(14);
  doc.text("Purchase Order Report", 150, 15); // Adjust X for center alignment

  // Draw the table
  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 25,
    theme: "grid",
    styles: {
      fontSize: 4,
      cellPadding: 1,
      overflow: 'linebreak',
    },
    headStyles: {
      fillColor: [10, 35, 82],
      textColor: 255,
      fontSize: 5,
    },
    columnStyles: {
      // Optional: You can dynamically assign width or wrap style if needed
      // 0: { cellWidth: 25 },
    },
    margin: { top: 25, left: 5, right: 5 },
    didDrawPage: (data) => {
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFontSize(5);
      doc.text(
        `Page ${data.pageNumber} of ${pageCount}`,
        data.settings.margin.left,
        doc.internal.pageSize.height - 10
      );
    },
  });

  doc.save("PurchaseOrder.pdf");
};

  const createPayload = (database, table, formData) => ({
    database,
    table,
    formData,
  });

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleCreate = () => {
      const formattedDate = getFormattedDate();
      
      // Combine form data with additional fields
      const updatedFormData = {
        ...formData,
        created_on: formattedDate,
        last_updated_on: formattedDate,
        entity_id: userCredentials.selectedentity,
        created_by: userCredentials.user_id,
        modified_by: userCredentials.user_id,
        last_updated_by: userCredentials.user_name,
        is_purchase_order : 1,
        is_milestone_added : 0
      };

    const payload = createPayload('paymentsuat', 'purchase_order', updatedFormData);

    const FileUploadCredentials = CreateData();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Create response:", response);
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error creating data:", error);
        setError("Error creating data");
      });
  };

  const handleUpdate = () => {

    const formattedDate = getFormattedDate();
    const updatedFormData = { ...formData,
        last_updated_on: formattedDate,
        modified_by: userCredentials.user_id,
        last_updated_by: userCredentials.user_name
 };

    // Remove primary_id from the copied formData
    delete updatedFormData.primary_id;
    const payload = {
      schema_name: 'paymentsuat',
      table: 'cost_centres',
      set_column : updatedFormData,
      'where' : [{"id":formData.id}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
        setEditMode(false); // Reset edit mode after updating
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };

const handleFileuploadSave = () => {
  const selectedRows = gridRef1.current.api.getSelectedRows();
  console.log("Selected Rows:", selectedRows);

  const selectedIds = selectedRows.map(row => row.id);

  if (selectedIds.length === 0) {
    alert("Please select at least one row.");
    return;
  }

    const payload = {
      'ids': selectedIds,
      'last_updated_by': userCredentials.user_name,  
    };

    const FileUploadCredentials = FetchsavePoRows();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
	alert("Records Saved Successfully!!!");
	setShowPopup(false);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
	alert("Error in Saving Records!!!");
        setError("Error updating data");
      });

};



const handlefileupload = () => {
  const formattedDate = getFormattedDate();

  const updatedFormData = {
    ...formData2,
    last_updated_on: formattedDate,
    modified_by: userCredentials.user_id,
    last_updated_by: userCredentials.user_name
  };
  console.log("updatedFormData",updatedFormData)

  const filePath = "/data/p2p/Production/Projects/TeamLease/PaymentsProcess/data/InstitutionalInvoices/UserUploaded/";  // Update this with the actual value

  const payload = {
    ...updatedFormData,
    file_path: filePath,
    source_name: "Institutional Invoice",
    config_id: 15,
    month: "2024-12", // or from formData.month
    skiprows: 0,
    table: "institutional_invoices",
    tenants_id: userCredentials.tenants_id,
    groups_id: userCredentials.groups_id,
    entities_id: userCredentials.selectedentity,
    user_id: userCredentials.user_id,
    source_type: "Institutional Invoice",
    process_id:36
  };

  const FileUploadCredentials = Fetchfileupload1();

  axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
    .then(response => {
      console.log("Upload response:", response);
      setEditMode(false);
      fetchFieldInfo3();
      window.location.reload();
    })
    .catch((error) => {
      console.error("Error uploading file:", error);
      setError("Error uploading file");
    });
};


  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

 if (loading) return <LoaderComponent loaderOpen={true}/>;

  return (
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab", fontSize: '18px' }}>
        Purchase Order Details
      </h2>


            <Tabs selectedIndex={activeTab} onSelect={(index) => handleTabChange1(index)}>
        <TabList>
          <Tab>View Purchase Orders</Tab>
          <Tab>Purchase Order Fileupload</Tab>
        </TabList>

      {error && <div style={{ color: "red" }}>{error}</div>}

        <TabPanel>

<div style = {{display:"flex",padding:"10px"}}>
<div>
  <img
    src={excelIcon}
    alt="Export to Excel"
    title="Download Excel"
    onClick={onBtnExportCSV} // Attach Excel export function
    style={{
      width: '28px',
      height: '28px',
      cursor: 'pointer',
      marginRight: '8px',
    }}
  />
</div>
<div>
  {/* PDF Icon */}
  <Icon
    name="file pdf outline"
    title="Download PDF"
    onClick={exportToPDF} // Attach PDF export function
    style={{
      fontSize: '28px',
      color: '#d9534f',
      cursor: 'pointer',
    }}
  />
</div>

</div>

          <div className="ag-theme-alpine" style={{height:'480px',width: '1600px',borderRadius:'8px' }}>
            <AgGridReact
              rowData={rowData}
              ref={gridRef}
              columnDefs={columnDefs1}
              pagination={true} // Enable pagination
              paginationPageSize={10} // Set the number of rows per page
              filter={true} // Enable filtering on the grid level

            />
          </div>
        </TabPanel>
        <TabPanel>
           <DynamicForm fields={fields3} formData={formData2} onInputChange={(name, value) => {
              setFormData2((prev) => ({ ...prev, [name]: value }));
            }} />
            <div className="submit-row">
              <button type="submit" className="submit-btn" onClick={handlefileupload}>
                Upload
              </button>
            </div>
          <div className="ag-theme-alpine" style={{
              overflowX: 'auto',
              overflowY: 'auto',
              borderRadius: '10px',
              width: `${5 * 250}px`,
              height : '400px'
         }}>
            <AgGridReact
              rowData={rowData1}
              columnDefs={columnDefs2}
              pagination={true} // Enable pagination
              paginationPageSize={8} // Set the number of rows per page
              filter={true} // Enable filtering on the grid level
            />
          </div>

        </TabPanel>

      </Tabs>
{showPopup && (
  <>
    {/* Overlay */}
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 999
      }}
    />

    {/* Popup */}
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        borderRadius: '10px',
        boxShadow: '0 0 10px rgba(0,0,0,0.3)',
        zIndex: 1000,
        padding: '16px',
        minWidth: '400px'
      }}
    >

      {/* AG Grid */}
      <div
        className="ag-theme-alpine"
        style={{
          overflowX: 'auto',
          overflowY: 'auto',
          borderRadius: '10px',
          width: `${5 * 250}px`,
          height: '420px'
        }}
      >
<AgGridReact
  ref={gridRef1}
  rowData={rowData2}
  columnDefs={columnDefs3}
  pagination={true}
  paginationPageSize={8}
  filter={true}
  rowSelection="multiple" // or "single"
  suppressRowClickSelection={true}
/>

      </div>
<div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '16px' }}>
  <button type="submit" className="submit-btn" onClick={handleFileuploadSave}>
    Save
  </button>
  <button type="submit" className="submit-btn" onClick={() => setShowPopup(false)}>
    Close
  </button>
</div>

    </div>
  </>
)}

    </div>
  );
}

export default PoCreation;
